import { createAction } from '@reduxjs/toolkit';

import type { Cart } from 'domains/cart';
import type { ConfirmationDetails } from './checkout.types';

export type SubmitOrderFulfilledPayload = {
  guid: string;
  order_number: string;
  total: number;
};

const initCheckout = {
  pending: createAction('checkout/initCheckout/pending'),
  fulfilled: createAction('checkout/initCheckout/fulfilled'),
  rejected: createAction('checkout/initCheckout/rejected'),
};

const initConfirmation = {
  pending: createAction<Cart>('checkout/initConfirmation/pending'),
  fulfilled: createAction('checkout/initConfirmation/fulfilled'),
  rejected: createAction('checkout/initConfirmation/rejected'),
};

const saveConfirmationDetails = {
  pending: createAction<ConfirmationDetails>('checkout/saveConfirmationDetails/pending'),
  fulfilled: createAction('checkout/saveConfirmationDetails/fulfilled'),
  rejected: createAction('checkout/saveConfirmationDetails/rejected'),
};

const submitOrder = {
  pending: createAction('checkout/submitOrder/pending'),
  fulfilled: createAction<SubmitOrderFulfilledPayload>('checkout/submitOrder/fulfilled'),
  complete: createAction<string>('checkout/submitOrder/complete'),
  rejected: createAction<string | undefined>('checkout/submitOrder/rejected'),
};

const resetCheckoutStatuses = createAction('checkout/resetCheckoutStatuses');

export default {
  initCheckout,
  initConfirmation,
  saveConfirmationDetails,
  submitOrder,
  resetCheckoutStatuses,
};
